import React from "react";
import ExecutionModeBadge from "./ExecutionModeBadge";
import ExecutionModeToggle from "./ExecutionModeToggle";
import "./productHeader.css";

export default function ProductHeader({ title, status, mode, modeControl, paperOnly = false }) {
  return <div className="product-header">
    <div className="product-header-identity">
      <h2 aria-label={title}>{title} <ExecutionModeBadge mode={mode} /></h2>
      <p>{status}</p>
    </div>
    <div className="product-header-mode">
      {paperOnly ? <><ExecutionModeToggle mode="paper" disabled liveDisabled label={`${title} execution mode`} title="This strategy supports PAPER mode only" /><small>Paper only</small></> : modeControl}
    </div>
  </div>;
}
